import { useSelector } from "react-redux";
//#region redux
import { AppState } from "store";
//#endregion
import { useAgentConversation } from "utils/helpers/agentConversationStore";

// The conversation of whoever is signed in, in the company she is in.
const useCurrentAgentConversation = () => {
  const personId = useSelector((state: AppState) => state.auth.loggedInUser.personId);
  const companyId = useSelector((state: AppState) => state.auth.selectedCompanyId ?? 0);
  return useAgentConversation(personId, companyId);
};

export default useCurrentAgentConversation;
